import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDialogBackButton } from "./useDialogBackButton";
import { useViewModel } from "./useViewModel";
import { PatientMobileNavBarViewModel } from "./PatientMobileNavBarViewModel";
import CloseIcon from "@mui/icons-material/Close";
import healthExLogo from "../Media/mobile-healthex-logo.png";
import { AvatarLaunchWrap, AvatarSpacer, LogoButton, NavLogo, NavRoot, NavTab, NavTabs, TabsBar } from "./PatientMobileNavBar.styles";
import { MobileLogoHeader } from "./MobileLogoHeader";
import { PatientProfileView } from "./PatientProfileView";
import { ProfilePopoverHeaderContainer } from "./PatientProfileView.styles";
import { MoreButton } from "./PatientHistoryView.styles";
import { UserAvatarView, UserAvatarViewSize } from "./UserAvatarView";
import { HXMobileSheetDialog } from "./HXMobileSheetDialog";
export const PatientMobileNavBar = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientMobileNavBarViewModel, props.container);
    const closeProfilePopover = React.useCallback(() => model.closePatientProfilePopover(), [model]);
    useDialogBackButton(model.profilePopoverOpen, closeProfilePopover);
    const [avatarPulse, setAvatarPulse] = React.useState(false);
    const avatarLaunchRef = React.useRef(null);
    const avatarTimerRef = React.useRef(null);
    React.useEffect(() => {
        return () => {
            if (avatarTimerRef.current !== null)
                window.clearTimeout(avatarTimerRef.current);
        };
    }, []);
    function handleAvatarLaunchClick() {
        setAvatarPulse(true);
        avatarTimerRef.current = window.setTimeout(() => {
            var _a;
            avatarTimerRef.current = null;
            const rect = (_a = avatarLaunchRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            model.onAvatarClick(rect !== null && rect !== void 0 ? rect : null);
            setAvatarPulse(false);
        }, 140);
    }
    return (_jsxs(NavRoot, { children: [_jsx(MobileLogoHeader, { onClickLogo: () => model.logoOnClick(), children: model.userForAvatar ? (_jsx(AvatarLaunchWrap, { ref: avatarLaunchRef, "$pulse": avatarPulse, children: _jsx(UserAvatarView, { user: model.userForAvatar, size: UserAvatarViewSize.SMALL, onClick: handleAvatarLaunchClick }) })) : (_jsx(AvatarSpacer, { "aria-hidden": true })) }), _jsx(TabsBar, { children: _jsxs(NavTabs, { value: model.selectedTabIndex, onChange: (_event, value) => model.onTabChange(Number(value)), variant: "fullWidth", "aria-label": t("History and sharing tabs"), children: [_jsx(NavTab, { label: model.isHealthWalletEnabled ? t("History") : t("Home"), disableRipple: true }), _jsx(NavTab, { label: t("Sharing"), disableRipple: true })] }) }), _jsx(HXMobileSheetDialog, { open: model.profilePopoverOpen, onClose: () => model.closePatientProfilePopover(), header: _jsxs(ProfilePopoverHeaderContainer, { children: [_jsx(LogoButton, { type: "button", onClick: () => {
                                model.closePatientProfilePopover();
                                model.logoOnClick();
                            }, "aria-label": "HealthEx home", children: _jsx(NavLogo, { src: healthExLogo, alt: "" }) }), _jsx(MoreButton, { type: "button", onClick: () => model.closePatientProfilePopover(), "aria-label": t("Close"), children: _jsx(CloseIcon, { sx: { width: 24, height: 24, color: "inherit" } }) })] }), children: _jsx(PatientProfileView, { container: props.container, onClose: () => model.closePatientProfilePopover(), externalHeader: true }) })] }));
});
